import { parseTimestamp, formatDate, toTimestamp } from 'commons/js/util/dateConverter'
import { MONTH_FORMAT } from 'commons/js/constants'

export default function buildPoiEventsParams ({ startDate, place }) {
    return {
        month: formatDate(parseTimestamp(startDate || toTimestamp()), MONTH_FORMAT),
        poiId: place.poi_id,
    }
}
